import { render, staticRenderFns } from "./myBanner.vue?vue&type=template&id=9a4a8eec&scoped=true&"
import script from "./myBanner.vue?vue&type=script&lang=ts&"
export * from "./myBanner.vue?vue&type=script&lang=ts&"
import style0 from "./myBanner.vue?vue&type=style&index=0&id=9a4a8eec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a8eec",
  null
  
)

export default component.exports